const removeNonAsciiChars = str => {
  // eslint-disable-next-line
  return str.replace(/[^\x00-\x7F]/g, '');
}

const convertToBoolean = value => {
  if (value === 'true') {
    return true
  } else if (value === 'false') {
    return false
  }
  return value
}

const sortValues = (a, b) => {
  const value1 = isNaN(Number(a)) ? a.toLowerCase() : a
  const value2 = isNaN(Number(b)) ? b.toLowerCase() : b
  if (value1 < value2) {
    return -1
  }
  if (value1 > value2) {
    return 1
  }
  return 0
}

export { removeNonAsciiChars, convertToBoolean, sortValues }
